// Hooks de planos e assinatura.
import { useQuery } from '@tanstack/react-query'
import type { PlanDto, PlansResponse, SubscriptionDto } from '@impulso/shared/api/billing'
import { api } from '../../lib/api'

export const usePlans = () => useQuery({ queryKey: ['plans'], queryFn: async () => (await api.get<PlansResponse>('/plans')).items, staleTime: 600_000 })
export const useSubscription = (accountId: string | undefined) =>
  useQuery({ queryKey: ['subscription', accountId], queryFn: () => api.get<SubscriptionDto>(`/accounts/${accountId}/subscription`), enabled: !!accountId })

const brlInt = (v: number) => v.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL', maximumFractionDigits: 0 })
export const priceLabel = (p: PlanDto) => (p.price > 0 ? brlInt(p.price) : 'Sob consulta')
export const money = (v: number) => v.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })

/** Lista de benefícios do plano a partir dos limites (texto simples). */
export function planFeatures(p: PlanDto): string[] {
  const e = p.entitlements
  const out: string[] = []
  if (p.kind === 'agency') {
    out.push(p.price > 0 ? `Até ${e.maxCompanies} empresas-clientes` : 'Quantas empresas precisar')
    out.push(`Até ${brlInt(e.managedSpendPerCompany)}/mês em anúncios por empresa`)
  } else {
    out.push(e.maxCompanies > 1 ? `Até ${e.maxCompanies} unidades` : '1 negócio')
    out.push(`Até ${brlInt(e.managedSpendPerCompany)}/mês em anúncios`)
  }
  out.push(e.autopilotModes.length > 1 ? 'Piloto automático (Copiloto e Automático)' : 'Sugestões para você aplicar')
  if (e.weeklyIdeas) out.push('Ideias de anúncios toda semana com IA')
  out.push(`${e.aiCreditsPerCompany} créditos de IA por mês${p.kind === 'agency' ? ' por empresa' : ''}`)
  if (e.clientPortal) out.push('Portal do cliente')
  if (e.whiteLabel) out.push('Relatórios com a sua marca')
  out.push(e.maxUsers >= 500 ? 'Usuários ilimitados' : `${e.maxUsers} ${e.maxUsers === 1 ? 'usuário' : 'usuários'}`)
  out.push(`Dados atualizados a cada ${e.syncIntervalMinutes >= 120 ? `${e.syncIntervalMinutes / 60} horas` : e.syncIntervalMinutes === 60 ? '1 hora' : `${e.syncIntervalMinutes} min`}`)
  return out
}
